import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "viewer"
};
const _hoisted_2 = {
  key: 1
};
import ImageItem from './ImageItem';
export default {
  __name: 'ImageHisViewer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '预览历史图',
      required: false
    },
    leftFiles: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  emits: ['update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const close = () => {
      emits('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: __props.title,
        onClose: close,
        width: "50%"
      }, {
        default: _withCtx(() => [__props.leftFiles.length > 1 ? (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 0,
          height: "400px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.leftFiles, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              style: {
                "width": "50%"
              }
            }, [_createVNode(_unref(ImageItem), {
              name: item.imgName,
              url: item.imgUrl
            }, null, 8, ["name", "url"])]);
          }), 128))])]),
          _: 1
        })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.leftFiles, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createVNode(_unref(ImageItem), {
            name: item.imgName,
            url: item.imgUrl
          }, null, 8, ["name", "url"])]);
        }), 128))]))]),
        _: 1
      }, 8, ["model-value", "title"]);
    };
  }
};